var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":"Rate Card: {organization_label}"}},[_c('v-container',[_c('m-settings-organization-rate-card-ctrl',{attrs:{"organization_id":this.$route.params.organization_id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }